import IconBase from '@/frontend/components/icons/IconBase';
export default {
  name: "PhoneIcon",
  components: {
    IconBase
  }
};